import {useContext} from "react";
import {AppContext} from "./AppContext";

export function useAppContext() {
    return useContext(AppContext);
}

export function withAppContext(Component: any) {
    return (props: any) => {
        const appContext = useAppContext();
        return <Component appContext={appContext} {...props} />;
    };
}
